<ng-container [formGroup]="form">
  @if (isGenerateOutline) {
    <div class="d-flex justify-content-center align-items-center gap-2">
      <div class="spinner-grow text-primary" role="status">
        <span class="visually-hidden">Generating the outline...</span>
      </div>
      <div>Generating the outline...</div>
    </div>
  } @else {
    <div class="d-flex flex-column gap-2">
      <app-refs-list [refs]="refs"></app-refs-list>
      <app-tiptap-editor
        formControlName="outline"
        [showToolbar]="fase"></app-tiptap-editor>
    </div>
  }
</ng-container>
